"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingCanceledStatuses = exports.MeetingRequiredStatuses = exports.MeetingStatusEnum = void 0;
var MeetingStatusEnum;
(function (MeetingStatusEnum) {
  /** требуется подтверждение хотя бы одним участником */
  MeetingStatusEnum[MeetingStatusEnum["accept_required"] = 0] = "accept_required";
  /** требуется подтверждение отмены */
  MeetingStatusEnum[MeetingStatusEnum["cancel_required"] = 10] = "cancel_required";
  /** отменён по желанию участников */
  MeetingStatusEnum[MeetingStatusEnum["canceled"] = 20] = "canceled";
  /** сорван по неявке преподавателя */
  MeetingStatusEnum[MeetingStatusEnum["disrupted"] = 21] = "disrupted";
  /** сорван по техническим причинам */
  MeetingStatusEnum[MeetingStatusEnum["eliminated"] = 22] = "eliminated";
  /** требуется подтверждение переноса времени */
  MeetingStatusEnum[MeetingStatusEnum["reschedule_required"] = 30] = "reschedule_required";
  /** подтвёрждён всеми участниками */
  MeetingStatusEnum[MeetingStatusEnum["accepted"] = 40] = "accepted";
  /** запущен */
  MeetingStatusEnum[MeetingStatusEnum["started"] = 50] = "started";
  /** завершён */
  MeetingStatusEnum[MeetingStatusEnum["finished"] = 60] = "finished";
})(MeetingStatusEnum = exports.MeetingStatusEnum || (exports.MeetingStatusEnum = {}));
exports.MeetingRequiredStatuses = [MeetingStatusEnum.accept_required, MeetingStatusEnum.cancel_required, MeetingStatusEnum.reschedule_required];
exports.MeetingCanceledStatuses = [MeetingStatusEnum.canceled, MeetingStatusEnum.disrupted, MeetingStatusEnum.eliminated];
